import React, { useState, useCallback } from 'react';
import classNames from 'classnames';

import useField from './useField';

import Field, { FieldProps } from './Field';

import classes from './style.module.scss';

const DEFAULT_MAX_LENGTH = 200;

export interface TextareaPropsDefault extends React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement> {
  ref?: React.Ref<HTMLTextAreaElement>
  inputClassName?: string
}

export type TextareaProps = TextareaPropsDefault & FieldProps

export type TextareaComponent = React.RefForwardingComponent<HTMLTextAreaElement, TextareaProps>

const Textarea: TextareaComponent = (props, ref) => {
  const { fieldProps, inputProps: { inputClassName, ...othersInputProps } } = useField<TextareaPropsDefault>(props);

  const [charCount, setCharCount] = useState(
    (othersInputProps.defaultValue ?? othersInputProps.value ?? '').toString().length
  );

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      setCharCount(event.target.value.length);
      othersInputProps.onChange?.(event);
    },
    [othersInputProps]
  );

  return (
    <Field {...fieldProps}>
      <div className={classes['textarea-wrapper']}>
        <textarea
          {...othersInputProps}
          ref={ref}
          maxLength={(othersInputProps.maxLength ?? DEFAULT_MAX_LENGTH)}
          onChange={handleChange}
          className={classNames(classes['input'], inputClassName)}
          disabled={fieldProps.loading}
        />
        <span className={classes['char-count']}>
          {charCount}/{(othersInputProps.maxLength ?? DEFAULT_MAX_LENGTH)}
        </span>
      </div>
    </Field>
  );
};

export default React.forwardRef(Textarea)